import type { SchemaFieldExpression } from "@/entities/schema";
import type { FormInstance } from "antd";

import { Form } from "antd";

import { evaluateExpressionField } from "./expression-field.helper";

export const useEvaluateExpressionField = (
  schema: SchemaFieldExpression,
  form: FormInstance
) => {
  const formValues = Form.useWatch([], form);

  return {
    unit: schema.unit,
    ...evaluateExpressionField(schema, formValues),
  };
};
